/* eslint-disable react/style-prop-object */

import { useState } from "react";
import Searchbar from "../../Helpers/Searchbar/Searchbar";
import trans from "../../../utils";

export default function IRHead({ setFilter, query, setQuery }) {
	return (
		<>
			<div className="bg-white p-16 d-flex align-items-baseline gap-3">
				<Searchbar
					style="search search-dark input-group"
					path={`${process.env.PUBLIC_URL}/assets/Search.svg`}
					placeholder={trans("Search")}
					value={query}
					onChange={setQuery}
				/>
				{/* <InputSelect
					placeholder={trans("Type")}
					options={typeOptions}
					formstyle="flex-grow-1 text-capitalize"
					onChange={(e) => {
						handleActive(e);
					}}
				/>
				<InputSelect
					placeholder={trans("device type")}
					options={deviceTypeOptions}
					formstyle="flex-grow-1 text-capitalize"
					onChange={(e) => {
						setFilter((prev) => ({ ...prev, deviceType: e }));
					}}
				/> */}
			</div>
		</>
	);
}
